import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-BJ6G5DFRYV");
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
